/**
 * The App component in this JavaScript code uses React Router to render routes defined in the routes
 * file along with a NavBar component.
 * @returns The App component is returning the NavBar component and the element generated by the
 * useRoutes hook using the routes defined in the routes file.
 */
import { useRoutes } from "react-router-dom";
import NavBar from "./components/Navbar";
import { routes } from "./routes";

function App() {
  const element = useRoutes(routes);

  return (
    <>
      <NavBar />
      {element}
    </>
  );
}

export default App;
